import { useContext } from 'react';
import { LoadingMapContext } from '../../../../providers/LoadingMapContext/context';
import { StyledNoUnderlineAnchor } from '../../../../StyledComponents';
import type { MouseEvent } from 'react';

interface Props {
  listingPath: string;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export function ListingModuleDetailsCta({ listingPath, onClick }: Props) {
  const {
    loadingByComponent: { ListingModule: isListingModuleLoading },
  } = useContext(LoadingMapContext);
  return (
    !isListingModuleLoading && (
      <StyledNoUnderlineAnchor href={listingPath} target="_self" onClick={onClick}>
        Details
      </StyledNoUnderlineAnchor>
    )
  );
}
